import React from 'react';

const Hero = (props) => {
  const { backgroundImage, headingText, paraText } = props;

  return (
    <div className="relative overflow-hidden bg-cover bg-no-repeat" style={{
      backgroundPosition: '50%',
      backgroundImage: `url('${backgroundImage}')`,
      height: '550px',
    }}>
      <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-[hsla(0,0%,0%,0.75)] bg-fixed">
        <div className="flex h-full items-center justify-center">
          <div className="px-6 text-center text-white md:px-12">
            <h1 className="mt-2 mb-2 text-5xl font-bold tracking-tight md:text-6xl xl:text-7xl">
              {headingText}
            </h1>
            <p className="mt-2 mb-4 text-lg font-bold tracking-tight">
              {paraText}
            </p>
           {/* <button type="button"
              className="rounded border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-lg font-large uppercase leading-normal text-neutral-50 transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-100 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200"
              data-te-ripple-init data-te-ripple-color="light">
              {buttonText}
            </button>  */}
         <div class="buttons">
  <button onClick={() => window.location.href = 'https://discord.gg/5x6AgqQe'} class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-5 rounded cursor-pointer">Join our Discord server</button>
</div>




          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
